import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Box from "@material-ui/core/Box";
//Screens
import Detalles from "./ViajeDetalles";
import PrimerPaciente from "./PrimerPaciente";
import SegundoPaciente from "./SegundoPaciente";
import Confirmacion from "./Confirmacion";
import ViajeDetalles from "./ViajeDetalles";
import LoadingServicio from "./LoadingServicio";
import moment, { add } from "moment";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import Swal from "sweetalert2";
import { BASE_URL } from "../../../utils/index";
import Exitoso from "../Exitoso";
import Error from "../Error";
import { postJson } from "../../../utils/postJson";

export default function Dialisis() {
  const isCompact = useMediaQuery("(max-width: 959.95px)");
  const drawerWidth = 240;
  const defaultProps = {
    bgcolor: "background.paper",
    m: 1,
    border: 1,
  };

  //request data

  useEffect(() => {
    const fetchMyAPI = async () => {
      let email2 = localStorage.getItem("email");
      let idCliente = localStorage.getItem("idCliente");
      let perfil = localStorage.getItem("perfil");
      let response2 = await postJson(
        `${BASE_URL}/servicios`,
        {
          email: email2,
        }
      );
      // console.log(response2);
      let pueblosObj = [];
      response2.pueblos.map((e, i) => {
        var obj = { title: e.pueblo };
        pueblosObj.push(obj);
      });
      let clientesObj = [];
      response2.clientes.map((e, i) => {
        var obj = { id: e.id, nombre: e.nombre };
        clientesObj.push(obj);
      });

      let destinosObj = [];
      response2.destinos.map((e, i) => {
        var obj = { title: e.destino };
        destinosObj.push(obj);
      });

      let pacientesObj = [];
      response2.pacientes.map((e, i) => {
        var obj = {
          id: e.id,
          idDireccion: e.idDireccion,
          etiqueta: e.etiqueta,
          coordenadas: e.coordenadas,
          nombre: e.nombre,
          pueblo: e.pueblo,
          direccion: e.direccion,
          numTelefono: e.numTelefono,
          nass: e.nass,
          numTelefono2: e.numTelefono2,
        };
        pacientesObj.push(obj);
      });

      let centrosAssistenciaObj = [];
      response2.centrosAsistencia.map((e, i) => {
        var obj = { title: e.label };
        centrosAssistenciaObj.push(obj);
      });

      setStateI({
        ...stateI,
        todosDestinos: destinosObj,
        pueblos: pueblosObj,
        turnosLLeida: response2.turnos,
        turnosArnau: response2.turnos,
        turnosIgualada: response2.turnos,
        email: email2,
        idCliente: idCliente,
        clientes: clientesObj,
        todosCentros: centrosAssistenciaObj,
        pacientes: pacientesObj,
        perfilLog: perfil,
        idClienteSol: perfil == 5 ? null : "",
        catalogLoaded: true,
      });
    };

    fetchMyAPI().catch((error) =>
      setStateI((current) => ({
        ...current,
        catalogLoaded: false,
        catalogError: error.message,
      }))
    );
  }, []);

  //Estilos
  const useStyles = makeStyles((theme) => ({
    appBar: {
      position: "relative",
    },
    layout: {
      boxSizing: "border-box",
      width: "auto",
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth + theme.spacing(2) * 2}px)`,
        marginLeft: drawerWidth + theme.spacing(2),
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.up("md")]: {
        width: 600,
        marginLeft: `calc(${drawerWidth}px + (100vw - ${drawerWidth}px - 600px) / 2)`,
        marginRight: "auto",
      },
    },
    paper: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2),
      [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3),
      },
    },
    stepper: {
      boxSizing: "border-box",
      width: "100%",
      padding: theme.spacing(3, 0, 5),
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(2, 0, 3),
      },
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end",
    },
    button: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  //Steps
  const steps = [
    "Información del viaje",
    "Primer paciente",
    "Segundo paciente *",
    "Confirma tu viaje",
  ];

  //step counter
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <ViajeDetalles
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleVehiculo={handleVehiculo}
            handleTurno={handleTurno}
            // handleDestino={handleDestino}
            handleDestino={handleDestinoViaje}
            handleCentros={handleCentros}
            handleConfirm={handleConfirm}
            activeStep={activeStep}
            handleClientes={perfilLog == 5 ? handleClientes : null}
            handleUrgente={handleUrgente}
            handleAlta={handleAlta}
            handleIngres={handleIngres}
          />
        );

      case 1:
        return (
          <PrimerPaciente
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleData={handleData}
            handlePueblo1={handlePueblo1}
            activeStep={activeStep}
            handlePacientes={handlePacientes1}
          />
        );

      case 2:
        return (
          <SegundoPaciente
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleData={handleData}
            handlePueblo2={handlePueblo2}
            activeStep={activeStep}
            handlePacientes={handlePacientes2}
          />
        );

      case 3:
        return (
          <Confirmacion
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            activeStep={activeStep}
          />
        );

      case 4:
        return <LoadingServicio values={values} />;

      default:
        break;
    }
  }

  //Estado global
  const [stateI, setStateI] = useState({
    catalogLoaded: false,
    catalogError: "",
    step: 0,
    tipo: "TURISME",
    turno: "",
    // destino: "",
    destino: {},
    direccionHospital: "",
    fecha: new Date(),
    fechaEnviar: "",
    fechaMostrar: "Aún no seleccionas fecha",

    idPrimerPaciente: "",

    idDireccionPaciente1: null,
    primerPaciente: "",
    puebloPrimerPaciente: {},
    telfPrimerPaciente: "",
    telfPrimerPaciente2: "",
    direccionPrimerPaciente: "",
    NASS1: "",

    idSegundoPaciente: "",

    idDireccionPaciente2: null,
    segundoPaciente: "",
    puebloSegundoPaciente: {},
    telfSegundoPaciente: "",
    telfSegundoPaciente2: "",
    direccionSegundoPaciente: "",
    NASS2: "",

    email: "",
    idCliente: "",
    nombreTurno: "",
    pueblos: [],

    turnosLLeida: [],
    turnosArnau: [],
    turnosIgualada: [],
    todosDestinos: [],
    turnos: [],
    clientes: [],
    pacientes: [],
    todosCentros: [],
    idClienteSol: null,
    perfilLog: null,
    urgente: false,
    alta: false,
    ingres: false,
  });

  const [activeStep, setActiveStep] = React.useState(0);

  const nextStep = () => {
    if (
      activeStep == 0 &&
      (stateI.tipo == "" ||
        // stateI.destino.title == "" ||
        Object.keys(stateI.destino).length === 0 ||
        stateI.nombreTurno == "" ||
        stateI.fechaEnviar == "" ||
        stateI.idClienteSol == null)
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Llena todos los datos por favor",
      });
    } else if (
      activeStep == 1 &&
      (stateI.NASS1 == "" ||
        stateI.primerPaciente == "" ||
        (typeof stateI.puebloPrimerPaciente === "object" &&
          Object.keys(stateI.puebloPrimerPaciente).length === 0))
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Llena todos los datos por favor",
      });
    } else {
      const { step } = stateI;
      setStateI({
        ...stateI,
        step: step + 1,
      });
      setActiveStep(step + 1);
    }
  };

  const prevStep = () => {
    const { step } = stateI;
    setStateI({
      ...stateI,
      step: step - 1,
    });
    setActiveStep(step - 1);
  };

  //handle fecha

  const handleConfirm = (date) => {
    //Dia semana
    let dia = moment(date).day();
    // console.warn("El dia de la semana es: " + dia);
    // console.warn("A date has been picked: ", date);
    //Fecha elegida
    const diaNum = date.getDate();
    const mesNum = date.getMonth() + 1;
    const yearNum = date.getFullYear();
    const horasNum = date.getHours();
    const minutos = date.getMinutes();
    //Fecha actual
    let today = new Date();
    let dd = today.getDate();
    let mm = String(today.getMonth() + 1);
    let yyyy = today.getFullYear();

    let todayFecha = moment().day();
    let fechaE = moment(date).day();

    if (date >= today || todayFecha == fechaE) {
      let pruebaFecha = `${yearNum}-${mesNum}-${diaNum}`;
      let fechaMostrar = pruebaFecha.split(" ");
      let dias = fechaMostrar[0].split("-");
      let fechaInput = `El ${moment(date).format("DD/MM/YYYY")}`;

      setStateI({
        ...stateI,
        fecha: date,
        fechaEnviar: pruebaFecha,
        fechaMostrar: fechaInput,
        horaString: "",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No puedes elegir una fecha pasada, escoge una correcta por favor",
      });
    }
  };
  //handle destino
  const handleDestino = (destino) => {
    if (destino == "LLEIDA SISTEMAS RENALES") {
      setStateI({
        ...stateI,
        destino: "LLEIDA",
        direccionHospital: destino,
        turnos: stateI.turnosLLeida,
      });
    } else if (destino == "LLEIDA TORNS ARNAU") {
      setStateI({
        ...stateI,
        destino: "LLEIDA",
        direccionHospital: destino,
        turnos: stateI.turnosArnau,
      });
    } else if (destino == "IGUALADA") {
      setStateI({
        ...stateI,
        destino: "IGUALADA",
        direccionHospital: destino,
        turnos: stateI.turnosIgualada,
      });
    }
  };

  //Handle turno
  const handleTurno = (value, turnos) => {
    const turno = turnos.find((opcion) => String(opcion.value) === String(value));
    setStateI((current) => ({
      ...current,
      nombreTurno: turno?.label || "",
      turno: turno?.value || "",
    }));
  };

  const handleData = (input) => (e) => {
    setStateI({
      ...stateI,
      [input]: e.target.value,
    });
  };

  const handleVehiculo = (value) => {
    setStateI({
      ...stateI,
      tipo: value,
    });
  };

  const handlePueblo1 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        puebloPrimerPaciente: {},
      });
    } else if (value.title != undefined) {
      setStateI({
        ...stateI,
        puebloPrimerPaciente: value,
      });
    } else {
      setStateI({
        ...stateI,
        puebloPrimerPaciente: { title: value },
      });
    }
  };

  const handlePueblo2 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        puebloSegundoPaciente: {},
      });
    } else if (value.title != undefined) {
      setStateI({
        ...stateI,
        puebloSegundoPaciente: value,
      });
    } else {
      setStateI({
        ...stateI,
        puebloSegundoPaciente: { title: value },
      });
    }
  };
  const handleClientes = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        idClienteSol: null,
      });
    } else if (value != undefined) {
      setStateI({
        ...stateI,
        idClienteSol: value,
      });
    } else {
      setStateI({
        ...stateI,
        idClienteSol: value,
      });
    }
  };
  const handlePacientes1 = (value) => {
    // console.log(value);
    if (value == null) {
      setStateI({
        ...stateI,
        idPrimerPaciente: "",
        idDireccionPaciente1: null,
        primerPaciente: "",
        puebloPrimerPaciente: {},
        telfPrimerPaciente: "",
        direccionPrimerPaciente: "",
        NASS1: "",
        telfPrimerPaciente2: "",
      });
    } else if (value != undefined) {
      setStateI({
        ...stateI,
        idPrimerPaciente: value.id,
        idDireccionPaciente1: value.idDireccion || null,
        primerPaciente: value.nombre,
        puebloPrimerPaciente: { title: value.pueblo },
        telfPrimerPaciente: value.numTelefono,
        direccionPrimerPaciente: value.direccion,
        NASS1: value.nass,
        telfPrimerPaciente2: value.numTelefono2,
      });
    } else {
      setStateI({
        ...stateI,
        idPrimerPaciente: value.id,
        idDireccionPaciente1: value.idDireccion || null,
        primerPaciente: value.nombre,
        puebloPrimerPaciente: { title: value.pueblo },
        telfPrimerPaciente: value.numTelefono,
        direccionPrimerPaciente: value.direccion,
        NASS1: value.nass,
        telfPrimerPaciente2: value.numTelefono2,
      });
    }
  };
  const handlePacientes2 = (value) => {
    // console.log(value);
    if (value == null) {
      setStateI({
        ...stateI,
        idSegundoPaciente: "",
        idDireccionPaciente2: null,
        segundoPaciente: "",
        puebloSegundoPaciente: {},
        telfSegundoPaciente: "",
        direccionSegundoPaciente: "",
        NASS2: "",
        telfSegundoPaciente2: "",
      });
    } else if (value != undefined) {
      setStateI({
        ...stateI,
        idSegundoPaciente: value.id,
        idDireccionPaciente2: value.idDireccion || null,
        segundoPaciente: value.nombre,
        puebloSegundoPaciente: { title: value.pueblo },
        telfSegundoPaciente: value.numTelefono,
        direccionSegundoPaciente: value.direccion,
        NASS2: value.nass,
        telfSegundoPaciente2: value.numTelefono2,
      });
    } else {
      setStateI({
        ...stateI,
        idSegundoPaciente: value.id,
        idDireccionPaciente2: value.idDireccion || null,
        segundoPaciente: value.nombre,
        puebloSegundoPaciente: { title: value.pueblo },
        telfSegundoPaciente: value.numTelefono,
        direccionSegundoPaciente: value.direccion,
        NASS2: value.nass,
        telfSegundoPaciente2: value.numTelefono2,
      });
    }
  };
  const handleDestinoViaje = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        destiono: {},
      });
    } else if (value.title != undefined) {
      setStateI({
        ...stateI,
        destino: value.title,
      });
    } else {
      setStateI({
        ...stateI,
        destino: value.title,
      });
    }
  };
  const handleCentros = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        direccionHospital: {},
      });
    } else if (value.title != undefined) {
      setStateI({
        ...stateI,
        direccionHospital: value.title,
        turnos: stateI.turnosLLeida,
      });
    } else {
      setStateI({
        ...stateI,
        direccionHospital: value.title,
        turnos: stateI.turnosLLeida,
      });
    }
  };
  const handleUrgente = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        urgente: value,
      });
    }
  };
  const handleAlta = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        alta: value,
      });
    }
  };
  const handleIngres = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        ingres: value,
      });
    }
  };
  //Handle fields on change
  const {
    step,
    tipo,
    turno,
    destino,
    direccionHospital,
    fecha,
    fechaEnviar,
    fechaMostrar,

    idPrimerPaciente,

    idDireccionPaciente1,
    primerPaciente,
    puebloPrimerPaciente,
    telfPrimerPaciente,
    telfPrimerPaciente2,
    direccionPrimerPaciente,
    NASS1,

    idSegundoPaciente,

    idDireccionPaciente2,
    segundoPaciente,
    puebloSegundoPaciente,
    telfSegundoPaciente,
    telfSegundoPaciente2,
    direccionSegundoPaciente,
    NASS2,

    email,
    idCliente,
    pueblos,

    nombreTurno,

    turnosLLeida,
    turnosArnau,
    turnosIgualada,
    todosDestinos,
    turnos,
    clientes,
    idClienteSol,
    perfilLog,
    pacientes,
    todosCentros,
    urgente,
    alta,
    ingres,
  } = stateI;

  const values = {
    step,
    tipo,
    turno,
    destino,
    direccionHospital,
    fecha,
    fechaEnviar,
    fechaMostrar,

    idPrimerPaciente,

    idDireccionPaciente1,
    primerPaciente,
    puebloPrimerPaciente,
    telfPrimerPaciente,
    telfPrimerPaciente2,
    direccionPrimerPaciente,
    NASS1,

    idSegundoPaciente,

    idDireccionPaciente2,
    segundoPaciente,
    puebloSegundoPaciente,
    telfSegundoPaciente,
    telfSegundoPaciente2,
    direccionSegundoPaciente,
    NASS2,

    email,
    idCliente,
    pueblos,
    nombreTurno,

    turnosLLeida,
    turnosArnau,
    turnosIgualada,
    todosDestinos,
    turnos,
    clientes,
    idClienteSol,
    perfilLog,
    pacientes,
    todosCentros,
    urgente,
    alta,
    ingres,
  };

  if (!stateI.catalogLoaded) {
    return stateI.catalogError ? (
      <main className={classes.layout}>
        <Error message={stateI.catalogError} />
      </main>
    ) : (
      <main className={classes.layout}>
        <LinearProgress aria-label="Cargando datos del servicio de diálisis" />
      </main>
    );
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="fixed" color="default" className={classes.appBar}>
        <Toolbar>
          <Link component={RouterLink} to="/" color="inherit">
            <IconButton edge="start" aria-label="menu">
              <ArrowBackIcon color="inherit" />
            </IconButton>
          </Link>
          <Typography variant="h6" color="inherit" noWrap>
            Pedir servicio de diálisis
          </Typography>
        </Toolbar>
      </AppBar>

      <main className={classes.layout}>
        <Box borderRadius={16} borderColor="primary.main" {...defaultProps}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              Pedir diálisis
            </Typography>
            <Stepper
              activeStep={activeStep}
              orientation={isCompact ? "vertical" : "horizontal"}
              className={classes.stepper}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              <React.Fragment>{getStepContent(activeStep)}</React.Fragment>
            </React.Fragment>
          </Paper>
        </Box>
      </main>
    </React.Fragment>
  );
}
